export const LOGIN = "/";
export const DASHBOARD = "/dashboard";
export const MARSHALLS = "/marshalls";
export const TRIPS = "/trips";
export const Staff = "/staff";
export const USER = "/users";
export const LEVEL = "/level";
export const ANNOUNCEMENTS = "/announcements";
export const PROFILE = "/profile";
export const SITEINFO = "/Siteinfo";
export const ADDMARSALLS = "/addmarshalls";
export const RESETPASSWORD = "/reset-password";
export const FORGETPASSWORD = "/forget-password";
export const RESENDCODE = "/resend-code";

